import { render, staticRenderFns } from "./ComponentDemo.vue?vue&type=template&id=289ac544&"
import script from "./ComponentDemo.vue?vue&type=script&lang=js&"
export * from "./ComponentDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports